import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ModalController, Events, Navbar, AlertController } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';
import { CustomToast } from '../../../../util/CustomToast';
import * as moment from 'moment';
import { ImageSelector } from '../../../../util/imageSelector/imageSelector';

@Component({
  selector: 'page-add-new',
  templateUrl: 'addNew.html',
  providers : [HttpClient, CustomToast]
})
export class AddNewPage {

  modalCtrl : ModalController;
	
  httpClient : HttpClient;
  baseUrl;

  image = {
    id : -1,
    filename : 'addimage.png'
  };

  categories;
  types;

  thenew = {
    state : 0,
    photo : '',
    video : '',
    title_es : '',
    title_en : '',
    summary_es : '',
    summary_en : '',
    tags_es : '',
    tags_en : '',
    url : '',
    press : '',
    date : '',
    idCategory : -1,
    idType : -1,
    idOwner : 1
  };

  minDate = moment().subtract(20,'years').toISOString();
  maxDate = moment().add(20,'years').toISOString();

  customToast : CustomToast;
  events : Events;

  @ViewChild(Navbar) navBar: Navbar;

	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,customToast : CustomToast,modalCtrl : ModalController, events : Events,public alertCtrl : AlertController) {
		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.baseUrl = this.httpClient.getBaseUrl();
    
    this.customToast = customToast;
    this.events = events;

    this.httpCallTypes();
    this.httpCallCategories();
  }
  
  ionViewDidLoad() {
    this.navBar.backButtonClick = (e:UIEvent)=>{
     let alert = this.alertCtrl.create({
      title : '¿Seguro que deseas salir?',
      message : 'Los datos no guardados se perderán',
      buttons : [
        {
          text : 'Salir',
          handler : () =>{
            this.navCtrl.pop();
          }
        },
        {
          text : 'Cancelar',
          role : 'cancel'
        }
      ]
     });

     alert.present();
    }
  }

  onClickImage(){
    let modal = this.modalCtrl.create(ImageSelector);
    modal.present();
    modal.onDidDismiss(image => {
      if(image){
        this.image = image;
        this.thenew.photo = image.filename;
      }
    });
  }

  httpCallTypes(){
    this.httpClient.get('/types?max=10000', (error,data)=>{
      this.types = data.json();
    });
  }

  httpCallCategories(){
    this.httpClient.get('/categories?max=10000', (error,data)=>{
      this.categories = data.json();
    });
  }

  httpPostNew(){
    this.httpClient.post('/news',this.thenew,(error,data)=>{
      if(!error){
        this.customToast.showMessage('Noticia creada correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('addNew:done');
      }
    });
  }

  onClickSave(){
    
    this.httpPostNew();
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/news/addNew/addNew.ts